import { UserIcon } from '@va/icons';
import classNames from 'classnames';

type UserInitialsProps = {
  initials?: string;
  notificationsCount?: number;
};

export function UserInitials({ initials, notificationsCount = 0 }: UserInitialsProps) {
  return (
    <div
      className={classNames('relative rounded-full bg-primary w-9 h-9 flex justify-center items-center text-white', {
        'mr-3': notificationsCount,
      })}
    >
      {initials ? initials.toUpperCase() : <UserIcon color='white' />}
      {notificationsCount > 0 && (
        <div className='absolute -right-3 w-6 h-6 bg-negative rounded-full text-center font-semibold text-xs leading-24'>
          {notificationsCount}
        </div>
      )}
    </div>
  );
}
